// declare const wx: any;
declare const WeixinJSBridge: any;

import {
  createPayOrderApi,
  fetchPayInfoApi,
  fetchPayCodeApi,
  fetchWxPayStatusApi,
} from "../api/api";

// 工具封装1
const fetchInfo = async (id?: string) => {
  const res = await fetchPayInfoApi(id);
  return res.r;
};

// 工具封装2
const fetchCodeInfo = async (id?: string) => {
  const res = await fetchPayCodeApi(id);
  return res;
};

// wx-js模式 支付
export const wxJsPay = async (id: string) => {
  const res = await createPayOrderApi(id);
  const params = await fetchInfo(res.data.orderId);
  const data = res.data;

  return new Promise((resolve, reject) => {
    WeixinJSBridge.invoke("getBrandWCPayRequest", params, (res: any) => {
      if (res.err_msg == "get_brand_wcpay_request:ok") {
        resolve(data);
      }
      if (res.err_msg == "get_brand_wcpay_request:fail") {
        reject(res);
      }
    });
  });
};

// 生成支付二维码
export const initWxPayCode = async (id: string) => {
  const res1 = await createPayOrderApi(id);
  const res2 = await fetchCodeInfo(res1.data.orderId);

  return new Promise(resolve => {
    resolve({ ...res1.data, ...res2.data });
  });
};

// 获取支付状态
export const fetchWxPayStatus = async (id: string) => {
  const { status } = await fetchWxPayStatusApi(id);

  return new Promise((resolve, reject) => {
    if (status === 1) {
      resolve({ message: "订单已支付", status });
    }
    if (status === 2) {
      reject({ message: "订单已取消", status });
    }
  });
};
